module.exports = __webpack_public_path__ + "static/flags/TW-e182ef93f0559a6be5dc267857ebf403.gif";